import script from "./ProductPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductPage.vue?vue&type=script&lang=ts&setup=true"

import "./ProductPage.vue?vue&type=style&index=0&id=f1d947d8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1d947d8"]])

export default __exports__